export default "__VITE_PUBLIC_ASSET__0af90732__"